{
  "cognito_user_pool_endpoint": "cognito-idp.eu-central-1.amazonaws.com/eu-central-1_057EL6htP",
  "cognito_user_pool_client_id": "cuavusmqt68v38p43cm290080",
  "domain": "kleksi.com",
  "short_domain": "klek.si",
  "servers": [
    {
      "id": "eu",
      "region": "eu-central-1"
    }
  ]
}
